
import 'styles/main.scss';

import Vue from 'vue';
import VueRouter from 'vue-router';

// import common modules
import 'igolf/ux';

// import router and main admin shell
import LoginMain from 'igolf/admin/login/comp/LoginMain.vue';
//import LoginForm from 'igolf/admin/login/comp/LoginForm.vue';

//Vue.use(VueRouter);

/*const router = new VueRouter({
	mode: 'history',
	base: '/admin/',
	routes: [
		{
			name: 'admin-login',
			path: '/login',
			component: LoginForm,
		}
	]
})*/

const app = new Vue({
	el: '#app-root',
	//router,

	render(h) {
		return h(LoginMain);
	}
})


